export default {
  actions: {
    copyLink: 'Copy Link',
    returnToContestDetails: 'Return to Contest Details',
  },
  stats: {
    entries: 'Entries',
    entry: 'Entry',
    prizes: 'Prizes',
  },
  contestType: {
    multientry: 'Multi Entry',
    singleentry: 'Single Entry',
    topx: 'Top X',
    multiplier: 'Multiplier',
    team_survivor: 'Team Survivor',
    team_pick_em: "Team Pick'Em",
    undefined: 'Unknown',
  },
  experienceLevel: {
    experienced: {
      title: 'Experienced user',
      description:
        'A user who has played in 50 or more public or private contests on Splash Sports.',
    },
    highly_experienced: {
      title: 'Highly experienced user',
      description:
        'A user who has <li>played in 500 or more public or private contests on Splash Sports</li><li>won $1,000 or more in 3 or more contests</li><li>won at least $2,500 in total on Splash Sports</li>',
    },
  },
  enterContestModal: {
    enterContest: {
      splashHostedMigrationMessage:
        'To provide you with the best tools and experience, all {{templateName}} contests are now hosted exclusively on our Splash platform.',
      title: 'Add entries',
      text: 'How many entries would you like to enter into this contest?',
      cashBalance: 'Cash Balance: {{balance}}',
      maxEntries__hasPlural: {
        one: '{{count}} max entry',
        other: '{{count}} max entries',
      },
      addEntriesEntertainmentOnly__hasPlural: {
        one: 'Add {{count}} entry',
        other: 'Add {{count}} entries',
      },
      depositToEnter: 'Deposit to enter',
      addEntries__hasPlural: {
        one: 'Add {{count}} entry: {{entryFee}}',
        other: 'Add {{count}} entries: {{entryFee}}',
      },
      free: 'FREE',
      close: 'Close',
      notEnoughCredits: 'Not enough credits',
      notEnoughCash: 'Not enough cash. Deposit to add entries.',
      insufficientFunds: 'Insufficient Funds',
      useCredits: 'Use Credits',
      useCreditsFirst: 'Use Credits first',
      zipCodeTitle: 'Before entering, please confirm your ZIP code',
      zipCodeLabel: 'ZIP code',
      zipCodePlaceholder: 'Zipcode',
      zipCodeError: 'Please enter a valid zip code',
      zipTermsPrefix: 'I am 18+ and agree to the',
      zipTermsLink: 'Terms & Conditions',
      verificationRequiredTitle: 'Verification Required',
      verificationRequiredSubtitle: 'Confirm your location and agree to terms.',
      voucherInvalid: 'Cannot use voucher for this contest:',
      voucherWarningMultiEntry:
        "Attention: Vouchers are 1-time use and can't be split across multiple entries (e.g. a $10 voucher cannot be used on 2 $5 entries).",
      voucherWarningHigherValue:
        "Attention: You're using a {{voucherValue}} voucher on a {{entryFee}} entry. Vouchers can only apply to 1 entry, the remaining balance will be discarded.",
    },
    success: {
      title: 'Entry successful',
      text__hasPlural: {
        one: 'You have added {{count}} entry into this contest',
        other: 'You have added {{count}} entries into this contest',
      },
      textPrefix: 'You have added',
      entryCount__hasPlural: {
        one: '{{count}} entry',
        other: '{{count}} entries',
      },
      textSuffix: 'into this contest.',
      balance: 'Your balance is now <balance>{{balance}}</balance>',
      creditsBalance: 'Your credits balance is now <balance>{{balance}}</balance>',
      redirecting: 'Redirecting to the contest in {{seconds}}',
      autoPicksMessage:
        'This contest has auto-picks enabled. The default setting has been selected but you can change your auto-pick strategy at any time. Your auto-pick strategy will be applied to all entries in this contest.',
      autoPicksMessageWithStrategy:
        'This contest has auto-picks enabled. Unless you change your auto pick strategy, the default setting of {{strategy}} will be selected if you do not make your pick before the deadline. Your auto-pick strategy will be applied to all entries in this contest.',
      gotIt: 'Got it!',
      editAutoPickLogic: 'Edit auto-pick settings',
    },
  },
  reviveEntryModal: {
    reviveEntry: {
      title: 'Revive my "{{entryName}}" entry',
      revivalsAvailable: '{{count}} entry revival available',
      revivalsAvailable_plural: '{{count}} entry revivals available',
      cost: 'Revival cost: {{cost}}',
      balance: 'Balance: {{balance}}',
      revive: 'Revive Entry',
      reviveFor: 'Revive entry: {{cost}}',
      depositToRevive: 'Deposit {{amount}} to revive',
      cancel: 'Cancel',
    },
    loading: {
      text: 'Preparing revival options...',
    },
    submitting: {
      title: 'Reviving Entry',
      text: 'Your entry is being revived. This may take a moment.',
    },
    success: {
      title: '"Entry 1" revived',
      titleWithNumber: '"Entry {{entryNumber}}" revived',
      revivalsRemaining: 'You have {{count}} more entry revival available',
      revivalsRemaining_plural: 'You have {{count}} more entry revivals available',
      noMoreRevivals: 'No more entry revivals available',
      balance: 'Your balance is now {{balance}}',
      continuePlaying: 'Continue Playing',
    },
    errors: {
      title: 'Revival Failed',
      BUYBACK_NOT_ENABLED: 'Entry revivals are not enabled for this contest',
      BUYBACK_DEADLINE_EXPIRED: 'Revival window has closed',
      ENTRY_NOT_ELIMINATED: 'This entry is not eliminated',
      BUYBACK_ALREADY_PURCHASED: 'Entry revival already purchased for this round',
      INSUFFICIENT_FUNDS: 'Insufficient funds to revive entry',
      GENERIC: 'Failed to revive entry. Please try again.',
    },
    revivalWindowClosed: 'Revival window closed',
    revivalLimitReached: "You've reached the revival limit for this entry",
    revivalNotAllowed: 'Revivals are no longer available for this contest',
    slateNotSettled: 'Cannot revive entry until the current slate has finished.',
  },
  enterContestError: {
    full: 'The contest is full',
    over: 'The contest has ended',
    cancel: 'The contest has been cancelled',
    inprogress: 'The contest has already started',
    default: 'You are not allowed to Create or Join entry',
    deadline: 'The contest deadline has passed',
    maxEntries: 'Max entries reached',
    locationLoading: 'Checking your location',
    locationInvalid: `Contest Type is not allowed in your location`,
    userInvalid: `Please verify your information before entering a contest`,
    voucherInvalid: 'The selected voucher cannot be applied to this contest',
    voucherValidation: {
      title: 'Voucher validation failed',
      message: 'The selected voucher cannot be applied to this contest. Please try again.',
    },
  },
  contestCard: {
    header: {
      locked: 'Locked',
      locks: 'Locks',
      firstTeeTimeTbd: 'First Tee Time (TBD)',
    },
    footer: {
      mySurvivors: 'My survivors',
      survivors: 'Survivors',
      myEntries: 'My entries',
      entries: 'Entries',
      entry: 'Entry',
      winning: 'Winning',
      won: 'Won',
      prizes: 'Prizes',
      segmented: 'Won (to date)',
      myRank: 'My rank',
      maxEntries: 'Max user entries',
      entriesAlive: 'Alive',
      entriesEliminated: 'Eliminated',
      missingPicks: 'Missing Picks',
    },
    banner: {
      alert__hasPlural: {
        one: '{{count}} alert',
        other: '{{count}} alerts',
      },
      eliminated: 'Eliminated',
      marketplace: 'Entry Marketplace',
    },
  },
  cardActions: {
    inviteManager: 'Manage invites',
    manageContest: 'Manage',
    massCommunication: 'Send post',
    entrantManager: 'Manage entrants',
    shareContest: 'Share this contest',
    shareContest_commish: 'Share',
    restartContest: 'Restart contest',
  },
  userStatusModals: {
    common: {
      explanation:
        'Why does Splash need my location? <link>View location sharing instructions</link>',
      contactSupport:
        'If you believe you are in a permitted location, you can try again or <link>contact support</link>',
      tryAgainCta: 'Try again',
      recheckLocationCta: 'Recheck location',
      dismissCta: 'Dismiss',
      contactSupportCta: 'Contact support',
    },
    userNotVerifiedModal: {
      title: 'You must be verified',
      text: 'Please complete identity verification on your account to {{desiredAction}}.',
      desiredActions: {
        makeEntries: 'make entries into this contest',
        deposit: 'deposit funds into your account',
        withdraw: 'withdraw funds from your account',
      },
      verifyNow: 'Verify now',
      dismiss: 'Dismiss',
    },
    verifyingDocumentsModal: {
      title: 'Verifying documents',
      text: 'Your documents are in the process of being verified. Try again later.',
      dismiss: 'Dismiss',
      contactSupport: 'Contact support',
    },
    locationPermissionRequired: {
      title: 'Location permission required',
      text: 'To use Splash, you must enable location permission in the settings of your browser.',
      cta: 'Recheck permissions',
    },
    invalidLocation: {
      title: 'Invalid location',
      text: `Some locations are restricted on Splash. Please make sure you are in a permitted location, then try again. <link>View permitted locations</link>`,
      troubleshootingTitle: 'Troubleshooting:',
      troubleshootingContactSupport:
        'If you are in a permitted location and have followed all troubleshooting steps please try again or <link>contact customer support</link>.',
    },
    locationError: {
      title: 'Location error',
      text: 'There was an issue verifying your location.',
    },
    locationRestriction: {
      title: 'Location restriction',
      text: 'Your current location ({{detectedLocation}}) prevents you from {{desiredAction}}. Please make sure you are in a permitted location, then try again. <link>View permitted locations</link>',
      textPredictionMarkets:
        'Your current location ({{detectedLocation}}) prevents you from using prediction markets. Please make sure you are in a permitted location, then try again. <link>View permitted locations</link>',
      note: '<bold>You are able to continue making picks in the contests that you currently have entries in.</bold>',
    },
    ageRestriction: {
      title: 'Age restriction',
      text: 'Some jurisdictions have different age requirements. Please make sure you are in a permitted location, then try again. <link>View permitted locations</link>',
    },
  },
  entrants: {
    list: {
      noEntrants: 'No entrants yet',
      error: 'There was an issue while loading entries',
      retry: 'Try again',
      errorSubtitle: 'Please try again later',
      following: 'Following',
      followsYou: 'Follows you',
      mutuallyFollowing: 'Mutually following',
      action: 'Follow',
      unfollow: 'Unfollow',
      viewChannel: 'View channel',
      entrants: 'Entrants',
      followers: 'Followers',
    },
  },
  modals: {
    glossaryModal: {
      title: 'Glossary',
      noDataFound: 'No glossary data found.',
      dismiss: 'Dismiss',
    },
    pickAlternatesModal: {
      title: 'Alternate picks',
      noDataFound: 'No alternates found.',
      dismiss: 'Dismiss',
    },
  },
  contestRestartCard: {
    sourceInfo: {
      moved: 'Moved from',
      ryp: 'RYP',
      ofp: 'OFP',
    },
    actionButtons: {
      dismiss: 'Dismiss',
      restart: 'Restart contest',
    },
    labels: {
      entries: 'Entries:',
    },
  },
  contestInviteCard: {
    inviterInfo: {
      invitedYou: 'invited you',
      contestRenewed: 'Contest renewed. Confirm your participation',
    },
    actionButtons: {
      decline: 'Decline',
      viewContest: 'View Contest',
      confirm: 'Confirm',
    },
    expirationInfo: {
      title: 'This invite will expire ',
      expired: 'Expired',
    },
  },
  contestNotificationCard: {
    contestInfo: {
      alerts: 'alerts',
      noAlerts: 'No alerts',
    },
  },
  offerFeed: {
    title__hasPlural: {
      one: 'Offer on your entries',
      other: 'Offers on your entries',
    },
    madeAnOffer: '{{handle}} made an offer',
    counteredYourOffer: '{{handle}} countered your offer',
    acceptedYourOffer: '{{handle}} accepted your offer',
    offerTerms: 'Offer:',
    counterTerms: 'Their counter:',
    boughtLabel: 'You bought:',
    shareLabel: 'Share:',
    entryUnknown: 'Entry',
    decline: 'Decline',
    dismiss: 'Dismiss',
    viewOffer: 'View offer',
    viewCounter: 'View counter',
    viewMyEntry: 'View my entry',
    offerExpires: 'This offer will expire',
    counterExpires: 'This counter will expire',
  },
  contestNotificationWidget: {
    newContestInvites__hasPlural: {
      one: 'New Contest Invite',
      other: 'New Contest Invites',
    },
    contestsNeedAttention__hasPlural: {
      one: 'Contest needs your attention',
      other: 'Contests need your attention',
    },
    contestRestarts__hasPlural: {
      one: 'Restart your previous contest',
      other: 'Restart your previous contests',
    },
    groupEntryRequests__hasPlural: {
      one: 'Group entry request',
      other: 'Group entry requests',
    },
    viewAll: 'View all',
    error: 'Failed to dismiss the contest restart notification',
  },
  guaranteedPlusCountdownPill: {
    title: 'Next Bonus: {{timeLeft}}',
  },
  additionalPayoutCountdownWidget: {
    title: '{{status}} Bonus revealed in',
    status: {
      next: 'Next',
      guaranteed: 'Guaranteed',
    },
    subtitle: 'Bonus unlocks when',
    time: {
      day__hasPlural: {
        one: 'Day',
        other: 'Days',
      },
      hour__hasPlural: {
        one: 'Hour',
        other: 'Hours',
      },
      minute__hasPlural: {
        one: 'Minute',
        other: 'Minutes',
      },
    },
  },
};
